import { useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";

export const inputCls = "w-full border border-navy/20 bg-white px-3 py-2 text-[15px] text-navy rounded outline-none focus:border-navy";
export const labelCls = "mb-1 block text-xs font-semibold uppercase tracking-wider text-muted";
export const btnDark = "inline-flex items-center gap-2 rounded bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-navy/90 disabled:opacity-60";
export const btnLine = "inline-flex items-center gap-2 rounded border border-navy/25 bg-white px-4 py-2 text-sm font-medium text-navy hover:border-navy disabled:opacity-60";

export function useDownload() {
  const [busy, setBusy] = useState(null);
  const download = async (path, name, key = path) => {
    setBusy(key);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
      return res.headers["x-missing-items"];
    } catch (e) {
      let detail = "Download failed";
      try { detail = JSON.parse(await e.response.data.text()).detail || detail; } catch (_) { /* keep default */ }
      toast.error(apiErrorMessage(detail));
    } finally { setBusy(null); }
    return null;
  };
  return { download, busy };
}
